<template>
  <div class="country">
    <div class="label mb-2">ประเทศ</div>
    <el-select
      id="countries"
      name="countries"
      placeholder="เลือกประเทศ"
      clearable
      filterable
      v-model="countryCode"
    >
      <el-option
        v-for="item in countryOptions"
        :key="item.code"
        :label="item.name"
        :value="item.code"
      >
      </el-option>
    </el-select>
    <p
      v-if="!countryCode"
      style="color: red;
      font-size: 12px"
    >
      กรุณาเลือกประเทศ
    </p>
  </div>
</template>

<script>
export default {
  props: ['countryOptions', 'code'],
  data() {
    return {
      countryCode: this.code,
    };
  },
  watch: {
    countryCode: function (val) {
      this.$emit('countrySelected', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.country {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 14px;
  color: #777;
}

.el-select {
  width: 250px;
}
</style>


// WEBPACK FOOTER //
// src/lib/components/CountrySelector.vue